import {
  BatterReportChartConfigDto,
  ChartType,
  PercentileRankingView,
  PercentileRankingsChartConfigDto,
  PitcherReportChartConfigDto,
} from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';
import GenericDraggableCheckboxConfig from 'components/Configs/GenericDraggableCheckboxConfig';

type ReportConfig = PitcherReportChartConfigDto | BatterReportChartConfigDto;

type Props<TReportConfig extends ReportConfig> = ChartConfigProps<PercentileRankingsChartConfigDto, TReportConfig> & {
  chartId: ChartType;
  chartKey: keyof TReportConfig;
};

const PercentileRankingsChartSidebar = <T extends ReportConfig>({
  extraChartData,
  setTempLayout,
  tempLayout,
  chartId,
  chartKey,
}: Props<T>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle(chartId, extraChartData)}
      </Typography>
      <GenericRadioConfig
        label={t('View data as:')}
        options={['Percentiles', 'Values'] satisfies PercentileRankingView[]}
        selected={extraChartData.viewDataAs}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            [chartKey]: { ...tempLayout[chartKey], viewDataAs: selected },
          })
        }
        disabled={false}
      />
      <GenericDraggableCheckboxConfig
        label={t('Visible stats')}
        draggableCheckboxes={extraChartData.visibleStats}
        setDraggableCheckboxes={(draggableCheckboxes) => {
          setTempLayout({
            ...tempLayout,
            [chartKey]: {
              ...tempLayout[chartKey],
              visibleStats: draggableCheckboxes,
            },
          });
        }}
        useShortLabels={true}
      />
    </div>
  );
};

const BatterPercentileRankingsChartSidebar = (props: ChartConfigProps<PercentileRankingsChartConfigDto, BatterReportChartConfigDto>) => {
  return (
    <PercentileRankingsChartSidebar chartId='BatterPercentileRankingsChart' chartKey='batterPercentileRankingsChartConfig' {...props} />
  );
};

const PitcherPercentileRankingsChartSidebar = (props: ChartConfigProps<PercentileRankingsChartConfigDto, PitcherReportChartConfigDto>) => {
  return (
    <PercentileRankingsChartSidebar chartId='PitcherPercentileRankingsChart' chartKey='pitcherPercentileRankingsChartConfig' {...props} />
  );
};

export { BatterPercentileRankingsChartSidebar, PitcherPercentileRankingsChartSidebar };
